import React, { useEffect, useRef, useState } from "react";
import System from "../../helper/system";
import $ from "jquery";
import Product from "@system/config/product";
import { isString } from "underscore";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import Manufacturers from "../UniversalSearch/Manufacturers";
import Categories from "../UniversalSearch/Categories";
import NewProductInformation from "../UniversalSearch/NewProductInformation";
import Documents from "../UniversalSearch/Documents";
import Videos from "../UniversalSearch/Videos";
import Events from "../UniversalSearch/Events";
import Articles from "../UniversalSearch/Articles";
import SItePage from "../UniversalSearch/SItePage";
import { __remove, __set } from "../../store/axios_indicator";
import useDebounce from "../../hooks/useDebounce";
import { useHomePageContentStore } from "src/hooks/HomePageContent";
import { useProductStore } from "src/hooks/product";
import Constants from "src/helper/Constants";
import NavigateToProductDetail from "../../component/custom/NavigateToProductDetail";

const defaulTabs = {
  manufacturerList: [],
  categoriesList: [],
  npiList: [],
  documentsList: [],
  articlesList: [],
  videosList: [],
  eventsList: [],
  sitePageList: []
}

const UniversalSearch = () => {
  const clsNm = "bs5 input-group flex-nowrap search-part"
  const [classToToggle, setClassToToggle] = useState(clsNm);
  const formRef = useRef(false);
  const [tabData, setTabData] = useState(defaulTabs)
  const [productList, setProductList] = useState({});
  const [DOM_id, set_DOM_id] = useDebounce("product", 1000);
  const [isDisplaySuggestion, setDisplaySuggestion] = useState(false);
  const [{ }, { get_home_page_content },] = useHomePageContentStore();
  const [{ }, { get_universal_product_search_list, get_universal_category_manufacturers_search_list, get_document_list }] = useProductStore();
  const [__check] = useAxiosIndicatorCheck();
  const [searchTerm, setSearchTerm] = useState(() => {
    const a = System.getParams().search;
    return a ? a : "";
  });
  const { UNIVERSAL_SEARCH_PARAM } = System.storageName
  const { NPI, SITE, EVENT, ARTICLE, DOCUMENT, CONTENT, VIDEO } = Constants.homePageAllTabs;

  useEffect(() => {
    // autopopulate
    $(".search-box .form-control").on("input", function () {
      if (!$(this).val()) {
        $(".search-box-dropdown").removeClass("d-none");
      } else {
        $(".search-box-dropdown").addClass("d-block");
      }
    });

    // search category hover
    $(".search-categories .search-categories-name").hover(
      function () {
        $(".search-categories-name").removeClass("active");
        $(this).addClass("active");
        let getValue = $(this).attr("data-target");
        $(".search-item").removeClass("active");
        $("#" + getValue).addClass("active");
      },
      function () { }
    );
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setClassToToggle(clsNm);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [formRef]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchTerm && searchTerm.length > 2 && isDisplaySuggestion) {
        await typingCompleted(searchTerm);
      } else {
        setClassToToggle(clsNm);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const getSearchStringBold = (string) => {
    return (
      <>
        {isString(string) && (
          <div className="ellipses" dangerouslySetInnerHTML={{
            __html: string.toUpperCase().replaceAll(
              searchTerm.toUpperCase(), "<strong>" + searchTerm.toUpperCase() + "</strong>"
            ),
          }} />
        )}
      </>
    );
  };

  const addClassOnTabByID = (DOM_id_d = "product") => {
    set_DOM_id(DOM_id_d);
  };
  useEffect(() => {
    $(".search-categories-name").removeClass("active");
    $("#" + DOM_id + "-tab-link").addClass("active");
    let getValue = $("#" + DOM_id + "-tab-link").attr("data-target");
    $(".search-item").removeClass("active");
    $("#" + getValue).addClass("active");
  }, [DOM_id]);

  const fetchFromServer = async (searchTerm) => {
    searchTerm = searchTerm.trim();
    __set("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL");
    let resNPI = [];
    let resDocuments = [];
    let resArticles = [];
    let resVideos = [];
    let resEvents = [];
    let resSite = [];
    let all_res = []
    let resManufactureSearch = []
    let resCategoryList = []
    let isDefaultOptSelected = false;

    const setDefaultTab = (tab) => {
      if (isDefaultOptSelected === false) {
        isDefaultOptSelected = true;
        addClassOnTabByID(tab);
        setClassToToggle(clsNm + " open");
      }
    }

    const resProducts = await get_universal_product_search_list(searchTerm);
    if (resProducts && Object.keys(resProducts).length > 0) {
      setProductList(resProducts);
      setDefaultTab("product") // 15009
    }

    const manufactureSearch = await get_universal_category_manufacturers_search_list(searchTerm);
    await Promise.all([
      await get_document_list({ search: searchTerm }, true),
      await get_home_page_content({ contentType: ARTICLE.contentType, searchTerm: searchTerm, pageNumber: 1, pageSize: 20 }),
      await get_home_page_content({ contentType: VIDEO.contentType, searchTerm: searchTerm, pageNumber: 1, pageSize: 20  }),
      await get_home_page_content({ contentType: EVENT.contentType, searchTerm: searchTerm, pageNumber: 1, pageSize: 20  }),
      await get_home_page_content({ contentType: SITE.contentType, searchTerm: searchTerm, pageNumber: 1, pageSize: 20  }),
      await get_home_page_content({ contentType: NPI.contentType, searchTerm: searchTerm, pageNumber: 1, pageSize: 20  }),
    ]).then((res) => {
      all_res = res;
      __remove("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL");
    }).catch(() => {
        __remove("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL");
    });

    if (manufactureSearch && manufactureSearch?.Manufacturer?.length > 0) {
      setDefaultTab("manufacturer")
      resManufactureSearch = manufactureSearch.Manufacturer
    }

    if (manufactureSearch && manufactureSearch?.Categories?.length > 0) {
      setDefaultTab("categories")
      resCategoryList = manufactureSearch.Categories
    }

    if (all_res[5][NPI.contentType]?.totalCount > 0) {
      setDefaultTab("npi")
      resNPI = all_res[5][NPI.contentType].webContentView
    }

    if (all_res[0]?.data.documentList?.length > 0) {
      setDefaultTab("documents")
      resDocuments = all_res[0]?.data.documentList
    }

    if (all_res[1][ARTICLE.contentType]?.totalCount > 0) {
      setDefaultTab("articles")
      resArticles = all_res[1][ARTICLE.contentType].webContentView
    }
    
    if (all_res[3][EVENT.contentType]?.totalCount > 0) {
      setDefaultTab("events")
      resEvents = all_res[3][EVENT.contentType].webContentView
    }

    if (all_res[4][SITE.contentType]?.totalCount > 0) {
      setDefaultTab("site")
      resSite = all_res[4][SITE.contentType].webContentView
    }
    
    if (all_res[2][VIDEO.contentType]?.totalCount > 0) {
      setDefaultTab("videos")
      resVideos = all_res[2][VIDEO.contentType].webContentView
    }

    setTabData({ npiList: resNPI, documentsList: resDocuments, articlesList: resArticles, eventsList: resEvents, sitePageList: resSite, videosList: resVideos, manufacturerList: resManufactureSearch, categoriesList: resCategoryList })
  };
  const letsSearch = (searchTerm, allTabsCount = {}) => {
    let c = System.getParams();

    for (const key in c) {
      delete c[key];
    }

    c.search = searchTerm;
    //history.pushState(null, null, "?" + $.param(c));
    history.pushState(null, null, window.location.href + "?" + $.param(c));

    if (searchTerm.length < 2) {
      searchTerm = "";
    }
    localStorage.setItem(UNIVERSAL_SEARCH_PARAM, searchTerm);
    //added by Ramya
    localStorage.setItem("universalSearch",true);
    c.page = 1;
    if (c.viewAll) {
      delete c.viewAll;
    }
    window.location.href = Product.getProductListingPageRouteURL({ search: searchTerm })
    return false;
  };

  const displayClearIconStatus = () => {
    return searchTerm.length > 0
  };

  const fromSubmitted = async (event) => {
    event.preventDefault();
    if (searchTerm.length < 2) {
      return false;
    }
    letsSearch(searchTerm);
  };

  const searchButtonPressed = async () => {
    let searchKey = searchTerm;
    if (searchTerm.length < 2) {
      localStorage.setItem(UNIVERSAL_SEARCH_PARAM, searchTerm);
      setSearchTerm(searchTerm);
      return false;
    }

    searchKey?.toLowerCase()
      .replace("+", "and")
      .replace("&", "and")
      .replace(".", "")
      .replace(" ", "-")
      .replace("/", "-")
      .replace(",", "");
    letsSearch(searchTerm); // allTabsCount
    return false;
  };

  const typingCompleted = async (searchTerm) => {
    setTabData(defaulTabs)
    setProductList({});
    await fetchFromServer(searchTerm);
    if (searchTerm.length < 1) {
      setClassToToggle(clsNm);
      setProductList({});
    }
    localStorage.setItem(UNIVERSAL_SEARCH_PARAM, searchTerm);
  };

  const onClearSearch = () => {
    setProductList({});
    setSearchTerm("");
    setClassToToggle(clsNm);
    $("#" + DOM_id + "-tab-link").addClass("active");
    let getValue = $("#" + DOM_id + "-tab-link").attr("data-target");
    $(".search-item").removeClass("active");
    $("#" + getValue).addClass("active");
  }

  return (
    <>
      <div className="col-xl-12 col-lg-12 col-12 header-search">
        <form
          ref={formRef}
          onSubmit={(event) => {
            event.preventDefault();
            fromSubmitted(event);
          }}
          className="search-box"
        >
          <div className={`global-search-input ${classToToggle}`}>
            <input type="text" className="form-control form-control-sm universal_search_input "
              id="search-dropdown" autoComplete="off"
              value={searchTerm}
              onPaste={(e) => {
                setSearchTerm(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setSearchTerm(e.target.value);
                }
              }}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setDisplaySuggestion(true);
              }}
              placeholder="Enter keyword, item, model or part numbers."
              style={{ border: "none" }}
            />

            {displayClearIconStatus() && (
              <i className="cursor-pointer fa fa-times-circle close-global-search"
                onClick={async () => { onClearSearch(); }} />
            )}

            <a href={void 0} className="bs5 btn btn-primary h-auto zindex-5"
              onClick={() => { searchButtonPressed(); }} >
              {__check("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL").status && (
                <i className="fa fa-spinner fa-spin" />
              )}
              {!__check("UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL").status && (
                <i className="fa fa-search" />
              )}
            </a>

            <div className="dropdown-menu search-part-dropdown" aria-labelledby="search-dropdown"            >
              <div className="bs5 row m-0 flex-nowrap h-100">
                <div className="col-auto p-0">
                  <div className="search-sidebar">

                    <div className="search-sidebar-title">
                      {searchTerm ? searchTerm :
                        System.getParams().search ? System.getParams().search : ""}
                    </div>

                    <div className="search-sidebar-inner">
                      <div className="search-categories">
                        <div className="search-categories-name"
                          id={"product-tab-link"}
                          data-target="search-1"
                          data-bs-target="search-1"
                          style={Object.keys(productList).length === 0 ? { display: "none" } : {}}                        >
                          <span>Products</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"manufacturer-tab-link"}
                          data-target="search-2"
                          data-bs-target="search-2"
                          style={tabData?.manufacturerList?.length === 0 ? { display: "none" } : {}}>
                          <span>Manufacturers</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"categories-tab-link"}
                          data-target="search-3"
                          data-bs-target="search-3"
                          style={tabData?.categoriesList?.length === 0 ? { display: "none" } : {}}>
                          <span>Categories</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"npi-tab-link"}
                          data-target="search-4"
                          data-bs-target="search-4"
                          style={tabData?.npiList?.length === 0 ? { display: "none" } : {}}>
                          <span>New Product Information</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"documents-tab-link"}
                          data-target="search-5"
                          data-bs-target="search-5"
                          style={tabData?.documentsList?.length === 0 ? { display: "none" } : {}}>
                          <span>Documents</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"articles-tab-link"}
                          data-target="search-6"
                          data-bs-target="search-6"
                          style={tabData?.articlesList?.length === 0 ? { display: "none" } : {}}>
                          <span>Articles</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"events-tab-link"}
                          data-target="search-7"
                          data-bs-target="search-7"
                          style={tabData?.eventsList?.length === 0 ? { display: "none" } : {}} >
                          <span>Events</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"other-tab-link"}
                          data-target="search-8"
                          data-bs-target="search-8"
                          style={tabData?.sitePageList?.length === 0 ? { display: "none" } : {}} >
                          <span>Site Pages</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                        <div className="search-categories-name"
                          id={"videos-tab-link"}
                          data-target="search-9"
                          data-bs-target="search-9"
                          style={tabData?.videosList?.length === 0 ? { display: "none" } : {}}>
                          <span>Videos</span>
                          <i className="fa fa-chevron-right" />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="bs5 col p-0">
                  <div className="search-content">
                    <div className="search-item" id="search-1">
                      <div className="search-item-title">
                        RECOMMENDED PRODUCTS
                      </div>
                      <div className="search-product-list">
                        {Object.keys(productList).length > 0 &&
                          Object.keys(productList).map((p, i) => (
                            <React.Fragment key={p}>
                              {i < 5 && (
                                <div className="search-product-list-item">
                                  <div className="search-product-list-item-info">
                                    <NavigateToProductDetail
                                      data={{ SEOManufacturerName: productList[p]?.SEOManufacturerName, SEOERPMFRPartNumber: productList[p]?.SEOERPMFRPartNumber, ItemNumber: productList[p]?.ItemNumber, ERPPartNumber: productList[p]?.ERPPartNumber, searchTerm: searchTerm ,isTypeHead : true}}>
                                      <div className="search-product-list-item-title">{productList[p]?.ERPMFRPartNumber ? productList[p].ERPMFRPartNumber : ""}</div>
                                    </NavigateToProductDetail>
                                    <div className="search-product-list-item-subtitle">
                                      {getSearchStringBold(productList[p].ManufacturerName)}
                                    </div>
                                    <div className="search-product-list-item-desc">
                                      {getSearchStringBold(productList[p].ShortDescription)}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </React.Fragment>
                          ))}
                      </div>

                      <div className="text-center mt-auto pb-3" style={Object.keys(productList).length === 0 ? { display: "none" } : {}}>
                        <a href={void 0} className="bs5 btn btn-sm btn-primary w240"
                          onClick={() => { searchButtonPressed(); }}>
                          VIEW ALL PRODUCT RESULTS
                        </a>
                      </div>
                    </div>

                    <div className="search-item" id="search-2">
                      <Manufacturers manufacturerList={tabData?.manufacturerList} searchText={searchTerm} />
                    </div>
                    <div className="search-item" id="search-3">
                      <Categories categoriesList={tabData?.categoriesList} searchText={searchTerm} />
                    </div>
                    <div className="search-item" id="search-4">
                      <NewProductInformation
                        searchText={searchTerm}
                        npiList={tabData?.npiList}
                        tab={NPI.abbr}
                      />
                    </div>
                    <div className="search-item" id="search-5">
                      <Documents
                        searchText={searchTerm}
                        documentsList={tabData?.documentsList}
                        tab={DOCUMENT.abbr}
                      />
                    </div>
                    <div className="search-item" id="search-6">
                      <Articles
                        searchText={searchTerm}
                        articlesList={tabData?.articlesList}
                        tab={CONTENT.abbr}
                      />
                    </div>
                    <div className="search-item" id="search-7">
                      <Events searchText={searchTerm} eventsList={tabData?.eventsList} tab={CONTENT.abbr} />
                    </div>
                    <div className="search-item" id="search-8">
                      <SItePage
                        searchText={searchTerm}
                        sitePageList={tabData?.sitePageList}
                        tab={CONTENT.abbr}
                      />
                    </div>
                    <div className="search-item" id="search-9">
                      <Videos searchText={searchTerm} videosList={tabData?.videosList} tab={CONTENT.abbr} />
                    </div>
                    
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* input-group end.// */}
        </form >
      </div >
    </>
  );
};

export default UniversalSearch;
